import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKitRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.5 14.8h4.3V22h-4.4v-7zM2.3 10.2h4.5v4.4q.1.2.2 0 .7-2.4 2.8-3.8 1.4-.6 3-.6h.7v4.5H9.9l-.2.1.5.2.6.2a5 5 0 0 1 2.1 1.7q1.3 2.1 1.3 4.5v.5H9.7v-1c-.1-1.1-.3-2.5-1.2-3.2q-.7-.6-1.6-.5l-.1 1V22H2.2zm23.6 12-.5-.1a5 5 0 0 1-3-1.4q-1.3-1.6-1-3.6V15H24l.8-.1v-.1l-.6-.2a4 4 0 0 1-3-3.3v-.9h4.7v2.1c.1.2 2.7 0 2.8.1v2.3H26l-.1.3v2.4c.2 1 1.5.8 2.2.6q.6 0 1-.3.2-.2.5-.2v3.8q-1 .5-2 .7l-.6.1zM17.2 9.8h.7l.5.1q1 .2 1.5 1.2c.4 1 0 2.2-.9 2.7l-.3.1c-1.4.5-3.4 0-3.6-1.7q0-1.8 1.6-2.3z" })
});
export default SvgKitRegularIcon;
